import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { NormalizedSwapFormValues } from '../../types'
import { SwapFormSchema } from './schema'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'

export interface NormalizeFormValuesParams {
  formValues: SwapFormSchema
  tokenRepository: TokenRepository
}

export function normalizeFormValues({
  formValues,
  tokenRepository,
}: NormalizeFormValuesParams): NormalizedSwapFormValues {
  const from = tokenRepository.findOneBySymbol(formValues.from)
  const to = tokenRepository.findOneBySymbol(formValues.to)
  const amount = NormalizedNumber(formValues.amount === '' ? '0' : formValues.amount)

  return {
    from,
    to,
    amount,
  }
}

export function getNormalizedFormValuesKey(values: NormalizedSwapFormValues): string {
  return [values.from.address, values.to.address, values.amount.toFixed()].join('-')
}
